      //     application_form_in_progress: {
      //       expense_attributes: {
import { call, put, select, takeLatest } from 'redux-saga/effects';

import {
  UPDATE_EXPENSE_START,
} from '../../actions/types'

import {
  updateExpenseSuccess,
  updateExpenseFailure,
} from '../../actions'

import { putLoanApplicationUser } from '../../requesters/loanApplicationUser'

import {
  getLoanApplicationId,
  getAssets, getLoanApplication, getLoanApplicationUser,
} from '../../reducers'

function* loanUpdateExpense({type, payload}) {
  const loanApplicationId = yield select(getLoanApplicationId);
  const loanApplication = yield select(getLoanApplication);

  const data = {
    loan_application_user: {
      expense_attributes: payload.expense || {}
    }
  }

  if (loanApplication.hasSecondaryApplicant) {
    data.loan_application = {
      ...payload.loan_application
    }

    if (payload.expense) {
      if (payload.expense.marital_status !== 'defacto' && typeof data.loan_application.secondary_is_defacto === "boolean") {
        data.loan_application.secondary_is_defacto = null
      }

      if (payload.expense.marital_status !== 'married' && typeof data.loan_application.secondary_is_spouse === "boolean") {
        data.loan_application.secondary_is_spouse = null
      }
    }
  }
  const { response, error } = yield call(putLoanApplicationUser, loanApplicationId, data)

  if (response) {
    yield put(updateExpenseSuccess(response))
  } else {
    yield put(updateExpenseFailure({
      expense: error.response.data.income,
      errors: error.response.data.errors
    }))
  }
}

export function* watchLoanUpdateExpense() {
  yield takeLatest(UPDATE_EXPENSE_START, loanUpdateExpense)
}
